<template>
    <div>
        <div class="vrm-drawer__backdrop" @click="handleClose"></div>
        <div v-if="isOpen" class="vrm-drawer mfp-with-anim">
            <div class="vrm-drawer__title">
                <h2>{{ title }}</h2>
                <vrm-icon-button
                    :icon-class="closeIcon"
                    data-cy="close-drawer-btn"
                    class="vrm-control-settings"
                    @click="handleClose"
                ></vrm-icon-button>
            </div>
            <slot />
        </div>
    </div>
</template>
<script>
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { AngularDirective } from '@/vue/decorators/angular-interop';

import VrmIconButton from '../molecules/VrmIconButton';

@Component({ components: { VrmIconButton } })
@AngularDirective('vrm-drawer')
export default class VrmDrawer extends Vue {
    @Prop()
    title;
    @Prop({ required: true })
    isOpen;
    @Prop()
    closeIcon;

    @Watch('isOpen')
    onDrawerToggle() {
        document.body.style.overflow = this.isOpen ? 'hidden' : '';
    }

    handleClose() {
        this.$emit('close');
    }
}
</script>
